import React from 'react';
import './UnitPanel.scss';
import { TranslationUtils } from '../../utils';
import { Unit } from 'guest-data-types-ts-lib';

interface UnitPanelReservationDetailsProps {
    unit: Unit;
}

export const UnitPanelReservationDetails: React.FC<UnitPanelReservationDetailsProps> = (props) => {
    const { unit } = props;
    const { name, city, state, country_code, photos } = unit;
    const imageUrl = photos.length > 0 ? photos[0].url.concat('?w=310') : null;
    const address = `${city}, ${state}, ${country_code}`;

    return (
        <div>
            <span tabIndex={0} className="heading-small title-reservation-medium">
                {TranslationUtils.get('payment_form_reservation_details')}
            </span>
            <div className="interline-reservation-details" />
            <div className="d-none d-md-block p-2">
                <div className="img-container-unit-res-detail my-24" style={{ backgroundImage: `url(${imageUrl})` }} />

                <div className={'type-body'}>
                    <div className="interline-reservation-details" />
                    <div tabIndex={0} className={'body-regular type-heading-small'}>
                        {name}
                    </div>
                    <div className={'body-regular'} tabIndex={0}>
                        {address}
                    </div>
                </div>
            </div>
        </div>
    );
};
